import React, { useState, useMemo, useContext } from "react";
import FareRule from "./FareRule";
import { AuthContext } from "../../Routes/AuthProvider"

const DomRoundTrip = ({
  onwardFlights = [],
  returnFlights = [],
  filteredOnwardFlights = [],
  filteredReturnFlights = [],
  filters,
  onFilterChange,
  loading,
  data,
  error,
  handleBookNow,
  requestBody,
}) => {
  const [selectedOnwardFlight, setSelectedOnwardFlight] = useState(null);
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);

  const { name, userName, roles, corporateId } = useContext(AuthContext);

  // const onwardList =
  //   filteredOnwardFlights?.length > 0 ? filteredOnwardFlights : onwardFlights;

  // const returnList =
  //   filteredReturnFlights?.length > 0 ? filteredReturnFlights : returnFlights;
  // SORTING (CHEAPEST ON TOP BY DEFAULT)
  const [onwardSortType, setOnwardSortType] = useState("DEPARTURE");
  const [returnSortType, setReturnSortType] = useState("DEPARTURE");
  const [selectedFare, setSelectedFare] = useState(null);
  const [loadFareRule, setLoadFareRule] = useState(false);
  const [activeTab, setActiveTab] = useState("info");
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [selectedFareMap, setSelectedFareMap] = useState({});
  const [fareRuleIndex, setFareRuleIndex] = useState(null);

  const sortFlights = (list = [], sortType) => {
    const copied = [...list];
    const getMinFare = (flight) => {
      if (flight.fares && flight.fares.length > 0) {
        return Math.min(...flight.fares.map(f => f.totalFare || 0));
      }
      return flight.fareDetails?.totalFare || 0;
    };

    const getDurationInMinutes = (duration) => {
      if (!duration) return 99999;
      const [h, m] = duration.split(":").map(Number);
      return h * 60 + m;
    };

    switch (sortType) {
      case "CHEAPEST":
        return copied.sort(
          (a, b) => getMinFare(a) - getMinFare(b)
        );

      case "FASTEST":
        return copied.sort(
          (a, b) =>
            getDurationInMinutes(a.totalDuration) -
            getDurationInMinutes(b.totalDuration)
        );

      case "NONSTOP":
        return copied.sort(
          (a, b) =>
            (a.segments?.length === 1 ? 0 : 1) -
            (b.segments?.length === 1 ? 0 : 1)
        );

      case "DEPARTURE":
        return copied.sort(
          (a, b) =>
            new Date(a.segments?.[0]?.departDateTime) -
            new Date(b.segments?.[0]?.departDateTime)
        );

      default:
        return copied;
    }
  };


  const sortedOnwardFlights = useMemo(() => {
    const list = filteredOnwardFlights ?? onwardFlights;
    return sortFlights(list, onwardSortType);
  }, [filteredOnwardFlights, onwardSortType]);

  const sortedReturnFlights = useMemo(() => {
    const list = filteredReturnFlights ?? returnFlights;
    return sortFlights(list, returnSortType);
  }, [filteredReturnFlights, returnSortType]);
  // Sorting End

  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };

  const formatTime = (dt) =>
    dt
      ? new Date(dt).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
      : "";

  const renderFlights = (list, type) => {
    if (!list || list.length === 0) return <p>No {type} flights found</p>;

    return list.map((f, idx) => {
      const segments = f?.segments || [];
      const firstSeg = segments[0] || {};
      const lastSeg = segments[segments.length - 1] || {};

      const airLineCode = firstSeg.airLineCode || "";
      const airLineName = firstSeg.airLineName || "Unknown Airline";

      const checked =
        type === "onward"
          ? selectedOnwardFlight === f
          : selectedReturnFlight === f;

      const stops = segments.length > 0 ? segments.length - 1 : 0;

      return (
        <div
          key={idx}
          className={`prodct_lst_round_main rept ${checked ? "selected-flight" : ""
            }`}
        >

          <div className="prodct_lst_round">
            {/* Airline */}
            <div className="item_bx">
              <div className="flight_img_round">
                <img
                  src={`/assets/images/Flight_Images/${airLineCode}.gif`}
                  alt={airLineName}
                  width="50"
                />
              </div>
              <div className="flight_se">
                <span>{airLineName}</span>
                {f?.segments?.map((seg, i) => (
                  <span className="multi_flgt" key={i}>
                    {seg.airLineCode}-{seg.flightNumber}
                    {i < f.segments.length - 1 && " || "}
                  </span>
                ))}
              </div>
            </div>

            {/* Depart */}
            <div className="item_bx">
              <div className="timer">
                <h4>{formatTime(firstSeg.departDateTime)}</h4>
                <p>{firstSeg.departCityName}</p>
              </div>
            </div>

            {/* Duration */}
            <div className="item_bx">
              <div className="deruation">
                <p>{f.totalDuration}</p>
                <div className="bordr_top">
                  <i className="fa fa-plane"></i>
                </div>
                <p className="stops">
                  {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                </p>
              </div>
            </div>

            {/* Arrival */}
            <div className="item_bx text-center">
              <div className="timer">
                <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                <p>{lastSeg.arrivalCityName || lastSeg.destination}</p>
              </div>
            </div>

            {/* Fare */}
            <div className="item_bx text-end">
              <input
                className="form-check-input"
                type="radio"
                name={type}
                checked={checked}
                onChange={() =>
                  type === "onward"
                    ? setSelectedOnwardFlight(f)
                    : setSelectedReturnFlight(f)
                }
              />
              <div className="flight_charge">
                <i className="fa fa-inr"></i>{" "}
                {Number(
                  selectedFareMap[f?.itemNo]?.totalFare ??
                  f?.fares?.[0]?.totalFare ??
                  0
                ).toLocaleString("en-IN")}

                <p className="type_frs px-3">

                  {
                    selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ??
                    f?.fares?.[0]?.journeyFareInfos?.[0]?.type ??
                    "Regular"
                  }

                </p>
                <p
                  className={`policyStatus domIn ${f?.policyStatus === "WithinPolicy"
                    ? "text-success"
                    : f?.policyStatus === "OutOfPolicy"
                      ? "text-danger"
                      : ""
                    }`}
                >
                  {f?.policyStatus && (
                    <img
                      src={
                        f.policyStatus === "WithinPolicy"
                          ? "/assets/images/approved.png"
                          : f.policyStatus === "OutOfPolicy"
                            ? "/assets/images/cancelled.png"
                            : ""
                      }
                      alt="status"
                      style={{ marginRight: "6px" }}
                    />
                  )}

                  {f.policyStatus}
                </p>
              </div>
            </div>
          </div>

          {/* DETAILS CLICK */}
          <div className="d-flex-rnd">
            <div className="click_detls_itrm"
              data-bs-toggle="offcanvas"
              data-bs-target="#FlightDetails1"
              onClick={() => {
                const firstSeg = f?.segments?.[0];
                const lastSeg = f?.segments?.[f?.segments?.length - 1];
                setSelectedFlight({
                  ...f,
                  origin: firstSeg?.departCityName,
                  destination: lastSeg?.arrivalCityName,
                });
              }}
            >
              Flight Details
              {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                <span style={{ color: 'green', marginLeft: '10px' }}>
                  {f.supSource}
                </span>
              )}
            </div>

            <div className="click_detls_itrm text-end"
              onClick={() => handleViewMoreFare(f)}
            >

              View More Fare
            </div>
          </div>
        </div>
      );
    });
  };

  // const onwardFare = Number(
  //   selectedOnwardFlight?.fares?.[0]?.totalFare || 0
  // );

  // const returnFare = Number(
  //   selectedReturnFlight?.fares?.[0]?.totalFare || 0
  // );

  const onwardFare = Number(
    selectedFareMap[selectedOnwardFlight?.itemNo]?.totalFare ||
    selectedOnwardFlight?.fares?.[0]?.totalFare ||
    0
  );

  const returnFare = Number(
    selectedFareMap[selectedReturnFlight?.itemNo]?.totalFare ||
    selectedReturnFlight?.fares?.[0]?.totalFare ||
    0
  );



  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };


  return (
    <>
      <div className="row">
        {/* Onward */}
        <div className="col-md-6 col-6 mb-300">
          <div className="from_to_plc">
            <div className="d_flex">
              <span className="plac_nam">
                {data.departureAirportCode}{" "}
                <i className="fa fa-arrow-right"></i>{" "}
                {data.arrivalAirportCode}
              </span>
              {data?.fareType && (
                <span style={{ color: "#ff0000", marginLeft: "8px" }}>
                  {data.fareType} ||
                </span>
              )}
              {(sortedOnwardFlights?.length || 0) > 0 && (
                <span style={{ color: "#ff0000", marginLeft: "10px" }}>
                  Showing Onward Flights : {sortedOnwardFlights.length}
                </span>
              )}
              <span style={{ color: "red" }}> || {formatDateForDisplay(data.onwardDate)}</span>
            </div>
            <div className="d-flex-reco mb-3">
              <div
                className={`fastest ${onwardSortType === "CHEAPEST" ? "active" : ""}`}
                onClick={() => setOnwardSortType("CHEAPEST")}
              >
                <img src="/assets/images/rupee.png" alt="Cheapest" />
                <h4>Cheapest</h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "FASTEST" ? "active" : ""}`}
                onClick={() => setOnwardSortType("FASTEST")}
              >
                <img src="/assets/images/speed.png" alt="Fastest" />
                <h4>Fastest</h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "NONSTOP" ? "active" : ""}`}
                onClick={() => setOnwardSortType("NONSTOP")}
              >
                <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
                <h4>Non Stop </h4>
              </div>

              <div
                className={`fastest ${onwardSortType === "DEPARTURE" ? "active" : ""}`}
                onClick={() => setOnwardSortType("DEPARTURE")}
              >
                <img src="/assets/images/flight-blue.png" alt="Departure" />
                <h4>Departure</h4>
              </div>
            </div>
          </div>
          <div className="scroll">
            {loading ? (
              <p className="text-center load">
                <span className="loader"></span>
              </p>
            ) : (
              renderFlights(sortedOnwardFlights, "onward")
            )}
          </div>
        </div>

        {/* Return */}
        <div className="col-md-6 col-6 mb-300">
          <div className="to_to_from_plc">
            <div className="d_flex">
              <span className="plac_nam">
                {data.arrivalAirportCode}{" "}
                <i className="fa fa-arrow-right"></i>{" "}
                {data.departureAirportCode}
              </span>
              {data?.fareType && (
                <span style={{ color: "#ff0000", marginLeft: "8px" }}>
                  {data.fareType} ||
                </span>
              )}

              {(sortedReturnFlights?.length || 0) > 0 && (
                <span style={{ color: "#ff0000", marginLeft: "10px" }}>
                  Showing Return Flights: {sortedReturnFlights.length}
                </span>
              )}

              <span style={{ color: "red" }}>|| {formatDateForDisplay(data.returnDate)}</span>
            </div>
            <div className="d-flex-reco mb-3">
              <div
                className={`fastest ${returnSortType === "CHEAPEST" ? "active" : ""}`}
                onClick={() => setReturnSortType("CHEAPEST")}
              >
                <img src="/assets/images/rupee.png" alt="Cheapest" />
                <h4>Cheapest</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "FASTEST" ? "active" : ""}`}
                onClick={() => setReturnSortType("FASTEST")}
              >
                <img src="/assets/images/speed.png" alt="Fastest" />
                <h4>Fastest</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "NONSTOP" ? "active" : ""}`}
                onClick={() => setReturnSortType("NONSTOP")}
              >
                <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
                <h4>Non Stop</h4>
              </div>

              <div
                className={`fastest ${returnSortType === "DEPARTURE" ? "active" : ""}`}
                onClick={() => setReturnSortType("DEPARTURE")}
              >
                <img src="/assets/images/flight-blue.png" alt="Departure" />
                <h4>Departure</h4>
              </div>
            </div>


          </div>
          <div className="scroll">
            {loading ? (
              <p className="text-center load">
                <span className="loader"></span>
              </p>
            ) : (
              renderFlights(sortedReturnFlights, "return")
            )}
          </div>
        </div>
      </div>

      {/* TOTAL */}
      <div className="total_amount Dom">

        {/* ONWARD FLIGHT */}
        {selectedOnwardFlight && (() => {

          const segments = selectedOnwardFlight.segments || [];
          const firstSeg = segments[0] || {};
          const lastSeg = segments[segments.length - 1] || {};
          const stops = segments.length > 0 ? segments.length - 1 : 0;

          return (
            <div className="onWords selected-flight">
              <div className="prodct_lst_round">

                <div className="item_bx">
                  <div className="flight_img_round">
                    <img
                      className="flight_i"
                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                      alt={firstSeg?.airLineName || ""}
                    />
                  </div>

                  <div className="flight_se">
                    <span>{firstSeg?.airLineName}</span>
                    <span>
                      {segments?.map((seg, i) => (
                        <span key={i}>
                          {seg.airLineCode}-{seg.flightNumber}
                          {i < segments.length - 1 && "/"}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="timer">
                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                    <p>{firstSeg?.departCityName}</p>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="deruation">
                    <p>{selectedOnwardFlight?.totalDuration}</p>
                    <div className="bordr_top">
                      <i className="fa fa-plane"></i>
                    </div>
                    <p className="stops">
                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                    </p>
                  </div>
                </div>

                <div className="item_bx text-center">
                  <div className="timer">
                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                    <p>{lastSeg?.arrivalCityName}</p>
                  </div>
                </div>

              </div>
            </div>
          );
        })()}


        {/* RETURN FLIGHT */}
        {selectedReturnFlight && (() => {

          const segments = selectedReturnFlight.segments || [];
          const firstSeg = segments[0] || {};
          const lastSeg = segments[segments.length - 1] || {};
          const stops = segments.length > 0 ? segments.length - 1 : 0;

          return (
            <div className="retrnWords">
              <div className="prodct_lst_round">

                <div className="item_bx">
                  <div className="flight_img_round">
                    <img
                      className="flight_i"
                      src={`/assets/images/Flight_Images/${firstSeg?.airLineCode || ""}.gif`}
                      alt={firstSeg?.airLineName || ""}
                    />
                  </div>

                  <div className="flight_se">
                    <span>{firstSeg?.airLineName}</span>
                    <span>
                      {segments?.map((seg, i) => (
                        <span key={i}>
                          {seg.airLineCode}-{seg.flightNumber}
                          {i < segments.length - 1 && "/"}
                        </span>
                      ))}
                    </span>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="timer">
                    <h4>{formatTime(firstSeg?.departDateTime)}</h4>
                    <p>{firstSeg?.departCityName}</p>
                  </div>
                </div>

                <div className="item_bx">
                  <div className="deruation">
                    <p>{selectedReturnFlight?.totalDuration}</p>
                    <div className="bordr_top">
                      <i className="fa fa-plane"></i>
                    </div>
                    <p className="stops">
                      {stops === 0 ? "Non-stop" : `${stops} Stop${stops > 1 ? "s" : ""}`}
                    </p>
                  </div>
                </div>

                <div className="item_bx text-center">
                  <div className="timer">
                    <h4>{formatTime(lastSeg?.arrivalDateTime)}</h4>
                    <p>{lastSeg?.arrivalCityName}</p>
                  </div>
                </div>

              </div>
            </div>
          );
        })()}


        {/* GRAND TOTAL */}
        <div className="retrnWord">
          <p className="Grand">Grand Total</p>
          <h1>
            <i className="fa fa-inr"></i>{" "}
            {(onwardFare + returnFare).toLocaleString("en-IN")}
          </h1>
        </div>

        {/* BUTTONS */}
        <div className="retrnWord mt-3">
          <button
            className="btn btn-primary mx-3"
            disabled={!selectedOnwardFlight || !selectedReturnFlight}
            onClick={() => {

              const onwardFareData =
                selectedFareMap[selectedOnwardFlight?.itemNo] ||
                selectedOnwardFlight?.fares?.[0];

              const returnFareData =
                selectedFareMap[selectedReturnFlight?.itemNo] ||
                selectedReturnFlight?.fares?.[0];

              const updatedOnward = {
                ...selectedOnwardFlight,
                selectedFare: onwardFareData,
                selectedFareIndex: onwardFareData?.selectedIndex ?? 0
              };

              const updatedReturn = {
                ...selectedReturnFlight,
                selectedFare: returnFareData,
                selectedFareIndex: returnFareData?.selectedIndex ?? 0
              };

              console.log("FINAL ROUND TRIP:", {
                onwardFareKey: updatedOnward?.selectedFare?.fareUniqueKey,
                returnFareKey: updatedReturn?.selectedFare?.fareUniqueKey
              });

              handleBookNow({
                onward: updatedOnward,
                return: updatedReturn
              });
            }}
          >
            Book Now
          </button>

          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result
          </button>
        </div>

      </div>

      {/* OFFCANVAS */}
      <div className="offcanvas offcanvas-end" id="FlightDetails1">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setActiveTab("info");
              setLoadFareRule(false);
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>

              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">

                {/* Flight Info */}

                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                    onClick={() => setActiveTab("info")}
                  >
                    Flight Information
                  </a>
                </li>

                {/* Fare Rules */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "fare" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                    onClick={() => {
                      setActiveTab("fare");

                      if (!selectedFlight?.itemNo) return;
                      setLoadFareRule(true);
                    }}
                  >
                    Fare Rules & Cancellation Change Rule
                  </a>
                </li>

                {/* Baggage */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "baggage" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                    onClick={() => setActiveTab("baggage")}
                  >
                    Baggage Information
                  </a>
                </li>



              </ul>

              <div className="tab-content" id="myTabContent">
                {/* ---------- TAB 1 : FLIGHT INFO ---------- */}
                <div
                  className="tab-pane fade show active"
                  id="kt_tab_pane_4"
                  role="tabpanel"
                >
                  <div className="seLct_tab_flight">
                    <h3 className="destnation">
                      {selectedFlight.origin}
                      <i className="fa fa-arrow-right"></i>
                      {selectedFlight.destination}
                    </h3>

                    <ul className="rlst_flight_detls">
                      <li>
                        {selectedFlight?.tripType === 1
                          ? "One Way"
                          : "Round Trip"}
                      </li>
                      <li>{selectedFlight?.selClass || "Economy"}</li>
                      <li>
                        {(selectedFlight?.adult || 0) +
                          (selectedFlight?.child || 0) +
                          (selectedFlight?.infant || 0)}{" "}
                        Traveller(s)
                      </li>
                      <li>
                        {new Date(
                          selectedFlight?.segments?.[0]?.departDateTime
                        ).toDateString()}
                      </li>
                    </ul>

                    <div className="d-flex flgt_dlts">
                      <div className="img_img_flight">
                        <img
                          className="flight_i"
                          src={`/assets/images/Flight_Images/${selectedFlight?.segments?.[0]?.airLineCode}.gif`}
                          alt={selectedFlight?.segments?.[0]?.airLineName}
                        />
                      </div>

                      <div className="text_img_t">
                        <h5>
                          {new Date(
                            selectedFlight?.segments?.[0]?.departDateTime
                          ).toDateString()}
                        </h5>
                        <p>
                          {selectedFlight.origin} -{" "}
                          {selectedFlight.destination} |{" "}
                          {selectedFlight?.segments?.[0]?.duration ||
                            "Duration N/A"}
                        </p>
                      </div>
                    </div>

                    <div class="d-flex-v">
                      <div class="d-flex-v-f">
                        <h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4>
                      </div>
                      <div class="d-flex-v-m"><span class="zero"></span></div>
                      <div class="d-flex-v-l">
                        <h4>{selectedFlight.origin}</h4>
                        <p>  {selectedFlight.segments?.[0]?.departAirportName}
                          {selectedFlight.segments?.[0]?.departTerminal
                            ? `, Terminal ${selectedFlight.segments?.[0]?.departTerminal}`
                            : ""}</p>
                      </div>
                    </div>

                    <div className="d-flex-v time_to_frm">
                      <div className="d-flex-v-l m-autto">
                        {selectedFlight.segments?.map((seg, index) => {
                          const departDate = new Date(seg.departDateTime);
                          const arrivalDate = new Date(seg.arrivalDateTime);
                          const getDurationBetween = (fromTime, toTime) => {
                            const start = new Date(fromTime);
                            const end = new Date(toTime);

                            const diffMs = end - start;
                            if (diffMs <= 0) return "";

                            const minutes = Math.floor(diffMs / 60000);
                            const hrs = Math.floor(minutes / 60);
                            const mins = minutes % 60;

                            return `${hrs > 0 ? hrs + "h " : ""}${mins}m`;
                          };
                          const departTime = departDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          });

                          const arrivalTime = arrivalDate.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          });

                          const isLast = index === selectedFlight.segments.length - 1;
                          const nextSeg = selectedFlight.segments[index + 1];

                          const layoverDuration =
                            nextSeg &&
                            getDurationBetween(seg.arrivalDateTime, nextSeg.departDateTime);

                          return (
                            <div key={index}>
                              {/* SEGMENT */}
                              <div className="d-flex mb-3 align-items-center">
                                {/* DATE + TIME */}
                                <div className="d-flex-v-f m-autto me-3">
                                  <h6>{departDate.toDateString()}</h6>
                                  <p className="mb-0">
                                    {departTime} ➜ {arrivalTime}
                                  </p>
                                </div>

                                <div className="d-flex-v-m fhty_rg">
                                  <i className="fa fa-plane flights"></i>
                                </div>

                                {/* AIRLINE */}
                                <div className="d-flex">
                                  <div className="img_flt">
                                    <img
                                      className="flight_i"
                                      src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                      alt={seg.airLineName}
                                    />
                                  </div>

                                  <div className="flt_name ms-2">
                                    {seg.airLineName} – {seg.airLineCode}-{seg.flightNumber}
                                  </div>
                                </div>
                              </div>

                              {/* STOP / LAYOVER INFO */}
                              {!isLast && (
                                <div className="layover-info">
                                  <p className="mb-0">
                                    <strong>Stop:</strong>{" "}
                                    {seg.arrivalCity ||
                                      seg.arrivalAirportName ||
                                      seg.destination}
                                  </p>
                                  <h4 className="text-red">
                                    Layover : {layoverDuration}
                                  </h4>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="d-flex-v">
                      {(() => {
                        const segments = selectedFlight.segments || [];
                        const lastSeg = segments[segments.length - 1] || {};

                        return (
                          <>
                            <div className="d-flex-v-f">
                              <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                            </div>

                            <div className="d-flex-v-m">
                              <span className="zero"></span>
                            </div>

                            <div className="d-flex-v-l">
                              <h4>{selectedFlight.destination || lastSeg.destination}</h4>
                              <p>
                                {lastSeg.arrivalAirportName}
                                {lastSeg.arrivalTerminal
                                  ? `, Terminal ${lastSeg.arrivalTerminal}`
                                  : ""}
                              </p>
                            </div>
                          </>
                        );
                      })()}
                    </div>



                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div className="row">
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={0}
                      />
                    </div>

                  </div>
                </div>
                <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p class="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p class="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Berry Journeys does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>


      {/* View More Fare */}
      <div className="offcanvas offcanvas-end" id="ViewMoreFare" tabIndex="-1" aria-labelledby="ViewMoreFareLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight?.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight?.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>

                <div className="flight_time">
                  {(() => {
                    const segments = selectedFlight?.segments || [];
                    const firstSeg = segments[0] || {};
                    const lastSeg = segments[segments.length - 1] || {};

                    return (
                      <>
                        <span>
                          <strong>
                            {firstSeg?.departCityName} ({firstSeg?.departAirportCode}) →{" "}
                            {lastSeg?.arrivalCityName} ({lastSeg?.arrivalAirportCode})
                          </strong>
                        </span>

                        <span>
                          <strong>{firstSeg?.airLineName}</strong>
                        </span>

                        <span>
                          <strong>
                            {firstSeg?.departDateTime
                              ? new Date(firstSeg.departDateTime).toDateString()
                              : ""}
                          </strong>
                        </span>

                        <span>
                          Departure at:{" "}
                          <strong>
                            {firstSeg?.departDateTime
                              ? formatTime(firstSeg.departDateTime)
                              : ""}
                          </strong>
                        </span>

                        <span>
                          Arrival at:{" "}
                          <strong>
                            {lastSeg?.arrivalDateTime
                              ? formatTime(lastSeg.arrivalDateTime)
                              : ""}
                          </strong>
                        </span>
                      </>
                    );
                  })()}
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares.map((fare, index) => {
                  const isSelected =
                    selectedFareMap[selectedFlight?.itemNo]?.selectedIndex === index;

                  return (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare?.journeyFareInfos?.[0]?.type}</h5>
                      <p
                        className={`policyStatus text-en ${fare?.policyStatus === "WithinPolicy"
                          ? "text-success"
                          : fare?.policyStatus === "OutOfPolicy"
                            ? "text-danger"
                            : ""
                          }`}
                      >
                        {fare?.policyStatus && (
                          <img
                            src={
                              fare.policyStatus === "WithinPolicy"
                                ? "/assets/images/approved.png"
                                : fare.policyStatus === "OutOfPolicy"
                                  ? "/assets/images/cancelled.png"
                                  : ""
                            }
                            alt="status"
                            style={{ marginRight: "6px" }}
                          />
                        )}

                        {fare.policyStatus}
                      </p>


                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>
                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>

                        <p
                          className="faReRule"
                          data-bs-toggle="modal"
                          data-bs-target="#FareRuleModal"
                          onClick={() => {
                            if (!selectedFlight?.itemNo) return;
                            setLoadFareRule(true);
                            setFareRuleIndex(index);
                          }}
                        >
                          Fare Rule
                        </p>
                        <button
                          className="btn btn-sm"
                          style={{
                            backgroundColor: isSelected ? "#110942" : "",
                            color: isSelected ? "#fff" : ""
                          }}
                          // disabled={isSelected}
                          onClick={() => {
                            setSelectedFareMap(prev => ({
                              ...prev,
                              [selectedFlight.itemNo]: {
                                ...fare,
                                selectedIndex: index
                              }
                            }));
                          }}
                        >
                          {isSelected ? "Selected" : "Select"}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>


      </div>

      {/* Fare Rule For Perticular Fare */}

      <div className="modal fade" id="FareRuleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Fare Rule</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={() => setLoadFareRule(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {selectedFlight && loadFareRule && fareRuleIndex !== null ? (
                  <>
                    <div className="col-md-12">
                      <FareRule
                        key={`${selectedFlight?.itemNo}_${loadFareRule}_${Date.now()}`}
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={fareRuleIndex}
                      />
                    </div>


                  </>
                ) : (
                  <p className="text-center">Loading fare rules...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default DomRoundTrip;
